<template>
  <div id="all" class="animated fadeIn">
    <b-row >
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="2">
                  <b-form-group label-for="month" label="Bulan">
                    <model-select
                      id="month"
                      :options="listMonth"
                      v-model="month"
                      placeholder="Bulan"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="year" label="Tahun">
                    <model-select
                      id="year"
                      :options="listYear"
                      v-model="year"
                      placeholder="Tahun"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="cro" label="Karyawan">
                    <model-select
                      id="cro"
                      :options="listEmployee"
                      v-model="myId"
                      placeholder="CRO"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group
                    label-for="customer_group"
                    label="Grup Konsumen"
                  >
                    <model-select
                      id="customer_group"
                      :options="listCustomerGroup"
                      v-model="myCustomerGroup"
                      placeholder="Grup Konsumen"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group
                    label-for="product_group"
                    label="Produk"
                  >
                    <model-select
                      id="product_group"
                      :options="listProductGroup"
                      v-model="myProductGroup"
                      placeholder="Produk"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="init"
                  >
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card id="orderan-by-employee">
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Orderan {{ showName }}</h4>
          <div class="small text-muted">
            {{ currentMonth + " " + currentYear }} / for customer group
            <strong>{{ showCustomerGroup }}</strong>
          </div>
        </b-col>
      </b-row>
      <bar-example
        v-if="!loading"
        :key="uniqueId('bar-cro-1')"
        :bar-label="task_complete.label"
        :bar-data="task_complete.dataset"
        chartId="chart-doughnut-01"
        :height="isMobile"
      ></bar-example>
      <loading v-else></loading>
    </b-card>

    <b-card-group class="mb-4">
      <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Konsumen based on task
        </div>
        <div class="small text-muted text-right mb-4">
          Total konsumen yang di pegang <b>{{ showName }}</b> based on pembagian
          tugas cro
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('coverage-customer')"
            :doughnut-label="customer_coverage.label"
            :doughnut-data="customer_coverage.data"
            chartId="coverage-customer"
          ></doughnut-example
          ><br />
          <table-total
            :tableData="customer_coverage"
            :title="'customer_coverage'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Konsumen Order
        </div>
        <div class="small text-muted text-right mb-4">
          Total konsumen <b>{{ showCustomerGroup }}</b> yang belum order - Product <strong>{{ showProductGroup }}</strong>
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-cro-2')"
            :doughnut-label="task_periode_with_product.label"
            :doughnut-data="task_periode_with_product.data"
            chartId="chart-doughnut-02"
          ></doughnut-example
          ><br />
          <table-total
            :clickAble="true"
            :tableData="task_periode_table_with_product"
            :title="'task_periode'"
            @showDetail="showDetailProduct"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-12 col-md-9 col-lg-9">
        <div class="h4 text-muted text-right">
          <i class="icon-home"></i>&nbsp;Toko Yang Perlu Di Follow Up
        </div>
        <div class="small text-muted text-right mb-4">
          List toko <b>{{ showCustomerGroup }}</b> yang <b>{{ showLastOrderType }}</b> - Product <strong>{{ showProductGroup }}</strong>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="!loading_suggest_visit_with_product && showExcel"
            class="btn btn-link"
            variant="excel icon"
            size="sm"
            @click="download2"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >
          <global-table
            :table-data="suggest_visit_with_product"
            :loading="loading_suggest_visit_with_product"
            :per-page="10"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields_suggest_visit"
            :redirect-detail="false"
            :show-add-button="false"
            :edit-button="false"
          ></global-table>
        </div>
      </b-card>

      <!-- <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Konsumen Order
        </div>
        <div class="small text-muted text-right mb-4">
          Total konsumen <b>{{ showCustomerGroup }}</b> yang belum order
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-cro-2')"
            :doughnut-label="task_periode.label"
            :doughnut-data="task_periode.data"
            chartId="chart-doughnut-02"
          ></doughnut-example
          ><br />
          <table-total
            :clickAble="true"
            :tableData="task_periode_table"
            :title="'task_periode'"
            @showDetail="showDetail"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
      <b-card class="col-sm-12 col-md-6 col-lg-6">
        <div class="h4 text-muted text-right">
          <i class="icon-home"></i>&nbsp;Toko Yang Perlu Di Follow Up
        </div>
        <div class="small text-muted text-right mb-4">
          List toko <b>{{ showCustomerGroup }}</b> yang <b>{{ showLastOrderType }}</b>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="!loading_suggest_visit && showExcel"
            class="btn btn-link"
            variant="excel icon"
            size="sm"
            @click="download"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >
          <global-table
            :table-data="suggest_visit"
            :loading="loading_suggest_visit"
            :per-page="7"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields_suggest_visit"
            :redirect-detail="false"
            :show-add-button="false"
            :edit-button="false"
          ></global-table>
        </div>
      </b-card> -->
    </b-card-group>

    <!-- <b-card-group class="mb-4">
      <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Konsumen Order
        </div>
        <div class="small text-muted text-right mb-4">
          Total konsumen <b>{{ showCustomerGroup }}</b> yang belum order - Product <strong>{{ showProductGroup }}</strong>
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('doughnut-cro-2')"
            :doughnut-label="task_periode_with_product.label"
            :doughnut-data="task_periode_with_product.data"
            chartId="chart-doughnut-02"
          ></doughnut-example
          ><br />
          <table-total
            :clickAble="true"
            :tableData="task_periode_table_with_product"
            :title="'task_periode'"
            @showDetail="showDetailProduct"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-12 col-md-9 col-lg-9">
        <div class="h4 text-muted text-right">
          <i class="icon-home"></i>&nbsp;Toko Yang Perlu Di Follow Up
        </div>
        <div class="small text-muted text-right mb-4">
          List toko <b>{{ showCustomerGroup }}</b> yang <b>{{ showLastOrderType }}</b> - Product <strong>{{ showProductGroup }}</strong>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="!loading_suggest_visit && showExcel"
            class="btn btn-link"
            variant="excel icon"
            size="sm"
            @click="download2"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >
          <global-table
            :table-data="suggest_visit_with_product"
            :loading="loading_suggest_visit_with_product"
            :per-page="10"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields_suggest_visit"
            :redirect-detail="false"
            :show-add-button="false"
            :edit-button="false"
          ></global-table>
        </div>
      </b-card>
    </b-card-group> -->

    <b-card v-if="openTotalAll">
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Jumlah transaksi / CRO</h4>
          <div class="small text-muted">
            {{ currentMonth + " " + currentYear }} / for customer group
            <strong>{{ showCustomerGroup }}</strong> - Product <strong>{{ showProductGroup }}</strong>
          </div>
        </b-col>
      </b-row>
      <b-button v-if="!loading_suggest_visit_with_product && showDetailRo"
        class="btn btn-link"
        variant="excel icon"
        size="sm"
        v-on:click.prevent="openDetail('transaction')"
        ><i class="fa fa-home"></i> Show Detail</b-button>
      <line-example
        v-if="!loading"
        :key="uniqueId('line-cro-1')"
        :line-label="cro_team.label"
        :line-data="cro_team.dataset"
        chartId="chart-line-01"
        :height="isMobile"
      ></line-example>
      <loading v-else></loading>

      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">
            Jumlah RO / CRO 
            <!-- Jumlah transaksi perhari (Box-/hari) -->
          </h4>
          <div class="small text-muted">
            {{ currentMonth + " " + currentYear }} / for customer group
            <strong>{{ showCustomerGroup }}</strong> - Product <strong>{{ showProductGroup }}</strong>
          </div>
        </b-col>
      </b-row>

      <b-button v-if="!loading_suggest_visit_with_product && showDetailRo"
        class="btn btn-link"
        variant="excel icon"
        size="sm"
        v-on:click.prevent="openDetail('transaction_box')"
        ><i class="fa fa-home"></i> Show Detail</b-button>
      <line-example
        v-if="!loading"
        :key="uniqueId('line-cro-2')"
        :line-label="total_box_cro_team.label"
        :line-data="total_box_cro_team.dataset"
        chartId="chart-line-02"
        :height="isMobile"
      ></line-example>
      <loading v-else></loading>
    </b-card>

    <!-- (Grafik bar total penjualan CRO per Box) -->
    <!-- nama variabel: total_box_sold_cro -->
    <b-card id="tes-grafik-bar" v-if="openTotalAll">
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">
            Total Penjualan Semua CRO per Box
          </h4>
          <div class="small text-muted">
            {{ currentMonth + " " + currentYear }} / for customer group
            <strong>{{ showCustomerGroup }}</strong> - Product <strong>{{ showProductGroup }}</strong>
          </div>
        </b-col>
      </b-row>
      <bar-example
        v-if="!loading"
        :key="uniqueId('bar-cro-2')"
        :bar-label="total_box_sold_cro.label"
        :bar-data="total_box_sold_cro.dataset"
        chartId="chart-doughnut-02"
        :height="isMobile"
      ></bar-example>
      <loading v-else></loading>
    </b-card>



     <b-modal
        ref="myModalRef"
        id="showDetail"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">{{title_show_detail}}</h3>
        </div>

        <div v-if="!loading">
          <b-row>
              <b-col sm="6" lg="2">
                <b-form-group label-for="today" label="Tanggal">
                  <model-select
                    id="today"
                    :options="listToday"
                    v-model="today"
                    @input="setToday"
                    placeholder="Today"
                  ></model-select>
                </b-form-group>
              </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <table class="attendance table-bordered">
                <tr
                  style="width:100%"
                  v-bind:class="{ green: index % 2 === 0 }"
                  v-for="(value, key, index) in data_detail[today]"
                  :key="uniqueId(key)"
                  :title="value"
                >
                  <td width="80%">
                    <div>{{ key }}</div>
                    <div><small>total handle cust GT: {{(total_task_customer[key] !== undefined) ? total_task_customer[key]['total_customer_gt'] : 0}}, total handle cust Non GT: {{(total_task_customer[key] !== undefined) ? total_task_customer[key]['total_customer_non_gt'] : 0}}</small></div>
                  </td>
                  <td width="20%" class="text-right">
                    {{ formatPrice(value) }}
                  </td>
                </tr>
              </table><br/>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="float-right">
                <b-button type="button" size="sm" variant="danger" @click="closeDetail">
                  <i class="fa fa-undo"></i> Back
                </b-button>
              </div>
             </b-col>
          </b-row>
        </div>

        <div v-else>
          <loading></loading>
        </div>
      </b-modal>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import * as moment from "moment";
import { ModelSelect } from "vue-search-select";
import tableTotal from "@/templates/TableTotal.vue";

import _ from "lodash";

export default {
  name: "dashboard-cro",
  components: {
    globalTable,
    Callout,
    loading,
    ModelSelect,
    LineExample,
    DoughnutExample,
    BarExample,
    tableTotal
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      customer_coverage: [],
      task_periode: [],
      task_periode_table: [],
      task_periode_with_product: [],
      task_periode_table_with_product: [],
      task_complete: [],
      total_box_sold_cro: [],
      suggest_visit: [],
      suggest_visit_with_product: [],
      my_order_today: [],
      cro_team: [],
      total_box_cro_team: [],
      loading: true,
      loading_suggest_visit: true,
      loading_suggest_visit_with_product: true,
      currState: '5',
      listMonth: [],
      listYear: [],
      listEmployee: [],
      listToday: [],
      listCustomerGroup: [],
      listProductGroup: [],
      listFlagWeekOrder: [],
      transaction_cro: [],
      transaction_box_cro: [],
      total_task_customer: [],
      data_detail: [],
      today: moment().format("DD"),
      year: moment().format("YYYY"),
      month: moment().format("MM"),
      myId: "all", //localStorage.getItem("employee_id"),
      myCustomerGroup: "2",
      myProductGroup: "1",
      title_show_detail: "",
      showCustomerID: null,
      showCustomerGroupID: null,
      showCustomerGroupProductID: null,
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MMMM"),
      fields_suggest_visit: [
        { key: "name", label: "Nama Konsumen", sortable: true },
        { key: "status_assets", label: "Asset In Customer", sortable: true },
        {
          key: "last_order_date",
          label: "Last Order",
          class: "width-150",
          sortable: true
        },

      ],
      fields_myorder: [
        { key: "order_number", label: "Order Number", sortable: true },
        { key: "total_price_plan", label: "Total", sortable: true }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    openTotalAll() {
      const division = localStorage.getItem("division_id");
      const position = localStorage.getItem("position_id");
      const nik = localStorage.getItem("nik");
      const allow_division = ["13", "4", "2", "10", "12", "16", "6"];
      const allow_position = ["52", "18", "2", "19", "23", "59", "62", "12", "67", "61", "77", "12", "84", "85"];
      const allow_employee = ["MBS22060005", "MBS23070002", "MBS25020007"];

      return ((allow_division.includes(division) && allow_position.includes(position)) || allow_employee.includes(nik))
        ? true
        : false;
    },
    showExcel() {
      const division = localStorage.getItem("division_id");
      const position = localStorage.getItem("position_id");
      const nik = localStorage.getItem("nik");
      
      const allow_division = ["13", "9", "16", "11", "6","4","2"];
      const allow_position = ["52", "14", "67", "21", "61", "22","77", "12", "84", "85"];
      const allow_employee = ["MBS22060005", "MBS23070002", "MBS25020007"];
      return ((allow_division.includes(division) && allow_position.includes(position)) || allow_employee.includes(nik))
        ? true
        : false;
    },
    showDetailRo() {
      const division = localStorage.getItem("division_id");
      const position = localStorage.getItem("position_id");
      const nik = localStorage.getItem("nik");
      const allow_division = ["13", "9", "16", "6","4","2"];
      const allow_position = ["52", "14", "67", "61","77", "12", "84", "85"];
      const allow_employee = ["MBS22060005", "MBS23070002", "MBS25020007"];
      return ((allow_division.includes(division) && allow_position.includes(position)) || allow_employee.includes(nik))
        ? true
        : false;
    },
    showName() {
      let name = "";
      this.listEmployee.forEach((v, k) => {
        if (v.value === this.showCustomerID) {
          name = v.text;
        }
      });
      return name;
    },
    showCustomerGroup() {
      let flag = "";
      this.listCustomerGroup.forEach((v, k) => {
        if (v.value === this.showCustomerGroupID) {
          flag = v.text;
        }
      });
      return flag;
    },

    showProductGroup() {
      let flag = "";
      this.listProductGroup.forEach((v, k) => {
        if (v.value === this.showCustomerGroupProductID) {
          flag = v.text;
        }
      });
      return flag;
    },
    //menampilkan tipe tanggal order terakhir (order 1 minggu terakhir, 2 minggu terakhir, etc)
    showLastOrderType() {
      let flag = "";
      this.listFlagWeekOrder.forEach((v, k) => {
        if (v.value === this.currState.toString()) {
          flag = v.text;
        }
      });
      return flag;
    },
    isMobile: function() {
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      if (check === true) {
        if (window.screen.width < 732) {
          return undefined;
        } else {
          return 100;
        }
      } else {
        return 100;
      }
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {
      const nik = localStorage.getItem("nik");
      const allow_employee = ["MBS22060005", "MBS18100001"];
      if(allow_employee.includes(nik)) {
        this.myCustomerGroup = (this.myCustomerGroup === '2') ? '1': this.myCustomerGroup ;
      } else if(nik === 'MBS25100001') {
        this.myCustomerGroup = (this.myCustomerGroup === '2') ? '58': this.myCustomerGroup ;
      }
      
      this.loading = true;
      this.loading_suggest_visit = true;
      this.loading_suggest_visit_with_product = true;
      this.showCustomerGroupID = this.myCustomerGroup;
      this.showCustomerGroupProductID = this.myProductGroup;
      this.showCustomerID = this.myId;
      this.currentYear = moment(this.year + "-" + this.month + "-01").format(
        "YYYY"
      );
      this.currentMonth = moment(this.year + "-" + this.month + "-01").format(
        "MMMM"
      );
      this.axios
        .get(
          "web/dashboard/all-dashboard-for-cro/" +
            this.month +
            "/" +
            this.year +
            "/" +
            this.myId +
            "/" +
            this.myCustomerGroup +
            "/"+
            this.myProductGroup +
            "/"
        )
        .then(response => {
          this.customer_coverage = response.data.coverage_customer;
          //this.task_periode = response.data.task_periode;
          //this.task_periode_table = response.data.task_periode_table;
          
          this.task_periode_with_product = response.data.task_periode_with_product;
          this.task_periode_table_with_product = response.data.task_periode_table_with_product;

          this.total_box_sold_cro = response.data.total_box_sold_cro;
          this.task_complete = response.data.task_complete;
          //this.suggest_visit = response.data.suggest_visit;
          //this.my_order_today = response.data.my_order_today;
          this.cro_team = response.data.cro_team;
          this.total_box_cro_team = response.data.total_box_cro_team;

          this.transaction_cro = response.data.transaction_cro;
          this.transaction_box_cro = response.data.transaction_box_cro;
          this.total_task_customer = response.data.total_task_customer;
          this.listToday = response.data.today;

          let temp = [];
          temp.push(this.task_complete.dataset);
          this.task_complete.dataset = temp;

          let temp2 = [];
          temp2.push(this.total_box_sold_cro.dataset);
          this.total_box_sold_cro.dataset = temp2;
          //this.showDetail(5);
          this.showDetailProduct(5);
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
          //this.loading_suggest_visit = false;
          //this.loading_suggest_visit_with_product = false;
        });
    },
    dropdown: function() {
      this.axios
        .get("web/dropdown/dashboard-cro/")
        .then(response => {
          this.listMonth = response.data.month;
          this.listYear = response.data.year;
          this.listEmployee = response.data.employee;
          this.listCustomerGroup = response.data.customer_group;
          this.listProductGroup = response.data.products_group;
          this.listFlagWeekOrder = response.data.flag_week_order;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Dashboard Sales",
          message: error.response.data.message
        });
      }
    },
    showDetail: function(state) {
      this.loading_suggest_visit = true;
      this.currState = state;
      this.axios
        .get(
          "web/dashboard/suggest-visit/" +
            state +
            "/" +
            this.myCustomerGroup +
            "/"
        )
        .then(response => {
          this.suggest_visit = response.data.suggest_visit;
        })
        .catch(error => {})
        .finally(() => {
          this.loading_suggest_visit = false;
        });
    },
    showDetailProduct: function(state) {
      this.loading_suggest_visit_with_product = true;
      this.currState = state;
      this.axios
        .get(
          "web/dashboard/suggest-visit-with-product/" +
            state +
            "/" +
            this.myCustomerGroup +
            "/" +
            this.myProductGroup 
        )
        .then(response => {
          this.suggest_visit_with_product = response.data.suggest_visit;
          this.loading_suggest_visit_with_product = false;
        })
        .catch(error => {})
        .finally(() => {
          this.loading_suggest_visit_with_product = false;
        });
    },
    // download: function() {
    //   this.loading_suggest_visit = true;
    //   this.axios({
    //     url:
    //       "web/export/customer/customer-last-order/" +
    //       this.currState +
    //       "/" +
    //       this.myCustomerGroup +
    //       "/",
    //     method: "GET",
    //     responseType: "arraybuffer" //before "blob"
    //   })
    //     .then(response => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "customer_last_order.xlsx");
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch(error => {
    //       if (error.response.status === 401) {
    //         this.expired(error, "");
    //       }
    //     })
    //     .finally(() => {
    //       this.loading_suggest_visit = false;
    //     });
    // },
     download2: function() {
      this.loading_suggest_visit_with_product = true;
      this.axios({
        url:
          "web/export/customer/customer-last-order-with-product/" +
          this.currState +
          "/" +
          this.myCustomerGroup +
          "/" +
          this.myProductGroup,
        method: "GET",
        responseType: "arraybuffer" //before "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "customer_last_order.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading_suggest_visit_with_product = false;
        });
    },
    openDetail: function(temp) {
      if(temp === 'transaction_box') {
        this.title_show_detail = "Jumlah RO / CRO";
        this.data_detail = this.transaction_box_cro;
      } else {
        this.title_show_detail = "Jumlah transaksi / CRO";
        this.data_detail = this.transaction_cro;
      }
      this.today = moment().format("DD");
      this.$refs.myModalRef.show();
    },
    closeDetail: function() {
      this.title_show_detail = '';
      this.data_detail = [];
      this.$refs.myModalRef.hide();
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    setToday: function(event) {
      this.today = event;
    }
  },
  mounted() {
    this.dropdown();
    this.init();
  }
};
</script>

<style></style>
